import styled from 'styled-components';
import { StyledContainerLoader, StyledLoader } from '../styled';

export const StyledContainer = styled(StyledContainerLoader)``;

export const StyledNewLoader = styled(StyledLoader)`
  position: fixed;
`;
